"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactScriptTag = _interopRequireDefault(require("react-script-tag"));
var _global = _interopRequireDefault(require("global"));
var _envConstants = require("../../env-constants");
var _ConfirmModal = _interopRequireDefault(require("./ConfirmModal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var googlePayEnv = _envConstants.ENV.NODE_ENV === 'production' ? 'PRODUCTION' : 'TEST';
var GooglePay = function GooglePay(_ref) {
  var amex = _ref.amex,
    visa = _ref.visa,
    mastercard = _ref.mastercard,
    currency = _ref.currency,
    apiKey = _ref.apiKey,
    paidAmount = _ref.paidAmount,
    onSuccess = _ref.onSuccess,
    handlePaymentValues = _ref.handlePaymentValues,
    checkoutTokenApi = _ref.checkoutTokenApi,
    setIsGooglePayActive = _ref.setIsGooglePayActive,
    googlePayMerchantId = _ref.googlePayMerchantId,
    girls = _ref.girls,
    guys = _ref.guys,
    baseUrl = _ref.baseUrl,
    minAge = _ref.minAge,
    product = _ref.product,
    travelInsuranceCheckBox = _ref.travelInsuranceCheckBox,
    weekTerms = _ref.weekTerms,
    destinationId = _ref.destinationId,
    scheduledPayments = _ref.scheduledPayments;
  var googlePayContainerRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    checkoutToken = _useState2[0],
    setCheckoutToken = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    scheme = _useState4[0],
    setScheme = _useState4[1];
  var baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
  };
  var tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
      gateway: 'checkoutltd',
      gatewayMerchantId: apiKey
    }
  };
  var allowedCardNetworks = [];
  if (visa) allowedCardNetworks.push('VISA');
  if (mastercard) allowedCardNetworks.push('MASTERCARD');
  if (amex) allowedCardNetworks.push('AMEX');
  var allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];
  var baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: allowedCardAuthMethods,
      allowedCardNetworks: allowedCardNetworks
    }
  };
  var cardPaymentMethod = Object.assign({}, baseCardPaymentMethod, {
    tokenizationSpecification: tokenizationSpecification
  });
  var isReadyToPayRequest = Object.assign({}, baseRequest);
  isReadyToPayRequest.allowedPaymentMethods = [baseCardPaymentMethod];
  var getGoogleTransactionInfo = function getGoogleTransactionInfo() {
    var finalPaidAmount = paidAmount / 100;
    return {
      totalPriceStatus: 'FINAL',
      totalPrice: finalPaidAmount.toString(),
      currencyCode: currency,
      countryCode: 'GB'
    };
  };
  var _onClick = function onClick(paymentsClient) {
    if (paymentsClient) {
      var paymentDataRequest = Object.assign({}, baseRequest);
      paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
      paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
      paymentDataRequest.merchantInfo = {
        merchantName: _envConstants.ENV.MERCHANT_NAME,
        // just user-visible name
        merchantId: googlePayMerchantId // coming from Google Pay Console
      };
      paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
        var paymentToken = JSON.parse(paymentData.paymentMethodData.tokenizationData.token);
        fetch(checkoutTokenApi, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: apiKey
          },
          body: JSON.stringify({
            type: 'googlepay',
            token_data: paymentToken
          })
        }).then(function (response) {
          return response.json();
        }).then(function (_ref2) {
          var token = _ref2.token,
            card_type = _ref2.card_type,
            scheme = _ref2.scheme,
            last4 = _ref2.last4,
            expiry_month = _ref2.expiry_month,
            expiry_year = _ref2.expiry_year,
            issuer_country = _ref2.issuer_country;
          if (token) {
            handlePaymentValues(card_type, scheme, token, last4, expiry_month, expiry_year, issuer_country);
          }
        })["catch"](function (ex) {
          return console.error('Failed payment', ex);
        });
      })["catch"](function (err) {
        // show error in developer console for debugging
        console.error(err);
      });
    } else {
      console.log('paymentsClient not defined');
    }
  };
  var handleScriptError = function handleScriptError(error) {
    console.error(error);
  };
  var handleScriptLoad = function handleScriptLoad() {
    if (_global["default"].google) {
      var paymentsClient = new _global["default"].google.payments.api.PaymentsClient({
        environment: googlePayEnv
      });
      paymentsClient.isReadyToPay(isReadyToPayRequest).then(function (response) {
        if (response.result) {
          // add a Google Pay payment button
          var button = paymentsClient.createButton({
            onClick: function onClick() {
              return _onClick(paymentsClient);
            },
            buttonType: 'plain'
          });
          setIsGooglePayActive(true);
          if (googlePayContainerRef) {
            googlePayContainerRef.current.appendChild(button);
          }
        }
      })["catch"](function (err) {
        // show error in developer console for debugging
        console.error(err);
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactScriptTag["default"], {
    src: "https://pay.google.com/gp/p/js/pay.js",
    onError: handleScriptError,
    onLoad: handleScriptLoad
  }), /*#__PURE__*/_react["default"].createElement("div", {
    ref: googlePayContainerRef
  }));
};
GooglePay.propTypes = {
  amex: _propTypes["default"].bool,
  visa: _propTypes["default"].bool,
  mastercard: _propTypes["default"].bool,
  currency: _propTypes["default"].string.isRequired,
  apiKey: _propTypes["default"].string.isRequired,
  paidAmount: _propTypes["default"].number.isRequired,
  onSuccess: _propTypes["default"].func.isRequired,
  handlePaymentValues: _propTypes["default"].func.isRequired,
  checkoutTokenApi: _propTypes["default"].string.isRequired,
  setIsGooglePayActive: _propTypes["default"].func.isRequired,
  googlePayMerchantId: _propTypes["default"].string.isRequired,
  girls: _propTypes["default"].string,
  guys: _propTypes["default"].string,
  baseUrl: _propTypes["default"].string.isRequired,
  minAge: _propTypes["default"].number,
  product: _propTypes["default"].string.isRequired,
  travelInsuranceCheckBox: _propTypes["default"].bool,
  weekTerms: _propTypes["default"].string,
  destinationId: _propTypes["default"].number,
  scheduledPayments: _propTypes["default"].array
};
var _default = exports["default"] = GooglePay;